<template>
	<ModalFormCard :action="action" class="modal-default">
		<template #title>Create default folder</template>

		<template #default="{ saving, errors }">
			<Input
				v-model:value="value.name"
				:hideError="false"
				groupClass="!bg-grey text-15"
				label="Folder name"
				name="name"
			/>

			<Error :error="error" />

			<div class="grid grid-cols-2 pt-6 gap-4">
				<ButtonSaving
					:disabled="saving"
					class="button-black h-12 col-span-1"
					type="button"
					@click="save"
				>
					Create folder
				</ButtonSaving>
			</div>
		</template>
	</ModalFormCard>
</template>

<script>
import Modal from "~/mixins/modal.js";

export default {
	mixins: [Modal],

	created() {},

	data() {
		return {
			value: {
				name: "",
			},
			error: false,
		};
	},

	methods: {
		save() {
			try {
				this.user.addDefaultFolder(this.value.name);
			} catch (error) {
				this.error = error.message;
				return;
			}

			this.$axios
				.post("/actions/user-update-settings/" + this.user.id, {
					settings: this.user.settings,
				})
				.then(() => {
					this.$event.$emit("modal-close");
				});
		},
	},

	computed: {
		user() {
			return this.$authSanctum.getUser();
		},
	},
};
</script>
